import {
  Box,
  Flex,
  GreyGrey70,
  IndigoIndigo60,
  Link,
  Primary12Regular
} from '@sequencehq/core-components'
import { inflect } from 'inflection'
import { IntegrationMoreInfo } from 'lib/docsLink/integrations'

export const SelectionFooter = (props: {
  selectedCount: number
  learnMoreHref?: string
}) => (
  <Flex
    {...Primary12Regular}
    color={GreyGrey70}
    justifyContent="space-between"
    paddingTop="8px"
  >
    <Link
      color={IndigoIndigo60}
      to={props.learnMoreHref ?? IntegrationMoreInfo.OverviewLink}
      rel="noreferrer noopener"
      target="_blank"
    >
      Learn more
    </Link>
    <Box
      color={GreyGrey70}
      userSelect="none"
      data-testid="importCustomers.customerSelection.selected"
    >
      {props.selectedCount} {inflect('customer', props.selectedCount)} selected
    </Box>
  </Flex>
)
